import React from "react";
import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButtonGroupProps,
  ToggleButton as MuiToggleButton,
} from "@mui/material";
import {styled} from "@mui/material/styles";
import {Colors} from "@bounce/shared/ui";

const ToggleButton = styled(MuiToggleButton)<{height?: string}>(({height = "35px", theme}) => ({
  fontSize: "14px",
  fontWeight: 600,
  height,
  color: Colors.primary._800,
  whiteSpace: "nowrap",
  borderRadius: "6px",
  border: `1px solid ${Colors.primary._800}`,
  "&.Mui-selected": {
    color: Colors.primary._800,
    backgroundColor: Colors.primary._200,
    border: `1px solid ${Colors.primary._800}`,
  },
  "&:hover": {
    border: `1px solid ${Colors.primary._800}`,
  },
  "&.Mui-selected:hover": {
    backgroundColor: Colors.primary._300,
    border: `1px solid ${Colors.primary._800}`,
  },
  "&.Mui-selected:disabled": {
    backgroundColor: Colors.primary._300,
    border: `1px solid ${Colors.primary._800}`,
  },
}));

type ToggleButtonGroupType = ToggleButtonGroupProps & {};

const ToggleButtonGroup = ({sx, ...props}: ToggleButtonGroupType) => {
  return (
    <MuiToggleButtonGroup
      sx={{
        ...sx,
      }}
      {...props}
    />
  );
};

export {ToggleButtonGroup, ToggleButton};
export type {ToggleButtonGroupType};
